import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Input} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {upKeyCode, downKeyCode} from '../../../../common/constants/keyCodes';
import * as Utils from '../../utils';

const focusInput = (index) => {
  const targetInput = document.getElementById(`partCode${index}`);

  if (targetInput) {
    targetInput.focus();
  }
};

class PartCode extends Component {
  constructor(props) {
    super(props);
    this.handlePartCodeChange = this.handlePartCodeChange.bind(this);
    this.handleWatchPart = this.handleWatchPart.bind(this);
    this.handlePartCodeBlur = this.handlePartCodeBlur.bind(this);
    this.handleNavigation = this.handleNavigation.bind(this);
  }

  handlePartCodeBlur() {
    const {index, order, orders, provider, partType} = this.props;
    const wasUpdated = !!order.oldCode && (order.oldCode !== order.partCode);
    const repeatedIndexes = Utils.findRepeatedCodes(orders, order.partCode);

    if (repeatedIndexes.length > 1) {
      this.props.addMessageBoxError(
        `El código ${order.partCode} se repite en las líneas ${repeatedIndexes.join(', ')} ` +
        'del pedido sin filtrar.'
      );
      this.props.changeSuggestedOrderParameter('verifying', false);
      return;
    }

    if ((order.partCode && !order.verified) && (wasUpdated || order.process === 'insert')) {
      this.props.checkProviderStockOrderCode(
        order,
        {provider, 'type': 'update', 'row': index},
        {partType},
      );
      return;
    }

    this.props.changeSuggestedOrderParameter('verifying', false);
  }

  handlePartCodeChange(event, data) {
    const {order} = this.props;
    this.props.editSuggestedOrderPartCode(data.value.toUpperCase(), order);
  }

  handleWatchPart() {
    const {index, order} = this.props;

    this.props.showOrderPartDetails(order.partCode, order.name, index);
  }

  handleNavigation(event) {
    const {index, rowsCount} = this.props;

    if (event.keyCode === upKeyCode && index > 0) {
      focusInput(index - 1);
    }
    if (event.keyCode === downKeyCode && index < rowsCount - 1) {
      focusInput(index + 1);
    }
  }

  render() {
    const {order, index} = this.props;

    return (
      <Input required
        id={`partCode${index}`}
        autoFocus={!order.partCode}
        className='input-part-code'
        size='mini'
        name='partCode'
        maxLength='20'
        disabled={order.deleted}
        value={order.partCode}
        placeholder='Código'
        onFocus={this.handleWatchPart}
        onBlur={this.handlePartCodeBlur}
        onChange={this.handlePartCodeChange}
        onKeyUp={this.handleNavigation}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const {filteredOrders, suggestedOrders, provider, partType} = state.providerStockOrders;

  return {
    provider,
    partType,
    'orders': suggestedOrders,
    'rowsCount': filteredOrders.length,
  };
};

const {
  addMessageBoxError,
  changeSuggestedOrderParameter,
  checkProviderStockOrderCode,
  editSuggestedOrderPartCode,
  showOrderPartDetails,
} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxError,
  changeSuggestedOrderParameter,
  checkProviderStockOrderCode,
  editSuggestedOrderPartCode,
  showOrderPartDetails,
})(PartCode);
